class Content {
	constructor(config) {
		this.config = Object.assign({
			scope: '.content.page'
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.on('change', 'input[name=deliverOption]', this.deliverOptionChanged.bind(this));
	}

	deliverOptionChanged(e) {
		$('.deliver-initial-hidden').removeClass('d-none');
		let selectedOption = $(e.currentTarget).val();
		let $advertisementText = $('textarea[name=advertisement_text]');
		if (selectedOption === 'text') {
			$advertisementText.attr('required', '');
		} else {
			$advertisementText.removeAttr('required', '');
		}

		let $fileupload = $('.deliver-option-upload.no-files input[name=materialfile\\[\\]]').first();
		if (selectedOption === 'upload') {
			$fileupload.attr('required', '');
		} else {
			$fileupload.removeAttr('required', '');
		}

		let hiddenClass = 'd-none';
		$('.deliver-option-wrapper').addClass(hiddenClass);
		$('.deliver-option-' + selectedOption).removeClass(hiddenClass);
	}

}

export default Content;
